// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bread-wrapper[data-v-3b4c5770] {\n  height: 100%;\n  line-height: 54px;\n  margin-left: 3px;\n}", ""]);
// Exports
module.exports = exports;
